var PhotoSwipe = require('./photoswipe');
var PhotoSwipeUI_Default = require('./photoswipe-ui-default');
// var Promise = require('../node_modules/promise-polyfill/promise.js');
// import 'whatwg-fetch'
import $ from 'jquery';
import axios from '../node_modules/axios/dist/axios.js'

var initPhotoSwipeFromDOM = function(gallerySelector) {
  var url = window.location.href;
  var urlArray = url.split('/');
  var section = urlArray[urlArray.length - 2];
  var slug = urlArray[urlArray.length - 1];
  var jsonUrl;

  if (section == 'events') {
    jsonUrl =  '/event-slideshow-images.json?slug=' + slug;
  } else {
    jsonUrl =  '/slideshow-images.json?slug=' + slug;
  }

  axios.get(jsonUrl)
  .then(function(response) {

    return response.data;
  }).then(function(json) {

    var thumbElements = $('.gallery-slide');

    var items = json.images;

    if (items.length === 0) {
      return;
    }

    var parseThumbnailElements = function(el) {

      var linkEl;

      for(var i = 0; i < thumbElements.length; i++) {
        linkEl = thumbElements[i]; // <a> element

        items[i].el = linkEl;

      }

      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {

        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {

            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) {
                continue;
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }

        if(index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };


    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        var itemIndex = parseInt(galleryElement.getElementsByClassName("gallery-slide")[index].getAttribute('data-pswp-uid') -1, 10);

        // define options (if needed)
        options = {

            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail

                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            },
            index: itemIndex,
            shareEl: false
        };

        // Pass data to PhotoSwipe and initialize it
        var gallery = new PhotoSwipe( pswpElement,PhotoSwipeUI_Default, items, options);

        gallery.init();

        gallery.listen('parseVerticalMargin', function(item) {
          var gap = item.vGap;
          gap.top = 100; // There will be 100px gap from top of viewport
          gap.bottom = 100; // and 100px gap from the bottom
        });
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll( gallerySelector );

    for(var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i+1);
      galleryElements[i].onclick = onThumbnailsClick;
    }

  });
};
if ($('.gallery-slide').length  > 0) {
  initPhotoSwipeFromDOM('.slideshow .gallery-slide');

}



// WEBPACK FOOTER //
// ./scripts/slideshow.js